import { v1 } from "uuid"
import {getAttrById, handleFindLayoutComponentOptionsCols, isExist} from "../index"
import { CATEGORY_MODE } from "@/consts"
const uuid = { v1 }
export const idsFilter = function (ids) {
  if (!ids) {
    return
  }
  Object.keys(ids).forEach(k => {
    //清除null,undefined, NaN
    if (ids[k] === null || ids[k] === undefined || (typeof ids[k] === "number" && isNaN(ids[k]))) {
      delete ids[k]
    }
  })
  return ids
}
export const objectSize = function (obj) {
  let size = 0,
    key
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++
  }
  return size
}

export const compareIds = function (currentIds, animateIds) {
  currentIds = idsFilter(currentIds) //当前组件的ids
  animateIds = idsFilter(animateIds) //当前动画的ids
  let isCurrentTarget = true
  delDirectionIndexOther(currentIds)
  delDirectionIndexOther(animateIds)
  if (objectSize(animateIds) === objectSize(currentIds)) {
    for (let key in animateIds) {
      if (key === "rectId" || key === "rect_id") {
        if (animateIds[key] != currentIds.rectId && animateIds[key] != currentIds.rect_id) {
          isCurrentTarget = false
        }
      } else if (key === "containerId" || key === "container_id") {
        if (animateIds[key] != currentIds.containerId && animateIds[key] != currentIds.container_id) {
          isCurrentTarget = false
        }
      } else {
        if(Array.isArray(animateIds[key])){
          for(let i=0;i<animateIds[key].length;i++){
            if(animateIds[key][i]!=currentIds[key][i]){
              isCurrentTarget = false
              break
            }
          }
        }else if (animateIds[key]?.toString() != currentIds[key]?.toString()) {
          isCurrentTarget = false
        }
      }
    }
  } else {
    isCurrentTarget = false
  }
  return isCurrentTarget
}
// 去掉自由布局 directionIndexOther 的这个属性
function delDirectionIndexOther(ids){
  if(objectSize(ids) === 3 && ids.hasOwnProperty("directionIndexOther")){
    delete ids.directionIndexOther
  }
}
// 判断是否是当前组件的子组件
function inChildRect(baseRect, rect) {
  // 删除控制当前组件的动画 排除掉画布的情况
  let isInclude = true
  // 判断当前动画的控制对象是不是在 被删除的组件内
  if(baseRect.hasOwnProperty("directionIndexOther") && !baseRect.hasOwnProperty("elementInLayoutId") ){
    delete baseRect.directionIndexOther
  }
  if (objectSize(rect) > 1 && objectSize(rect) >= objectSize(baseRect)) {
    for (let idKey in baseRect) {
      if (baseRect[idKey] !== rect[idKey]) {
        isInclude = false
        break
      }
    }
  }
  return isInclude
}

// 深度修改uid----排除掉动画里面的uid
function deepChangeUidExcludeAnimate(origin, res) {
  // const res = {}
  deepChange(origin, res)
  // res为新，旧uid的对应关系
  return res
  function deepChange(org, res) {
    if (org && typeof org === "object") {
      for (let k in org) {
        if (k.indexOf("Animates") > -1) {
          // 动画内存的uid 不改变
          continue
        }
        if (typeof org[k] === "object") {
          deepChange(org[k], res)
        } else if (k === "uid" && (!org[k].length || !res[org[k]])) {
          const uid = uuid.v1()
          res[org[k]] = uid
          org[k] = res[org[k]]
        } else if(k === "cellId" && org[k] !== "root"){
          const cellId = uuid.v1()
          res[org[k]] = cellId
          org[k] = res[org[k]]
        }
      }
    }
  }
}
/**
 *   用于轮播的单元格同步，动画的同步
 */
export const swiperColAnimateSync =function(data){
  // 动画设置项已经通过同步的时候处理完成
  // 此处需要处理 将作用于当前单元格的swiperContent_id 替换到为对应的swiperContent_id
  data.content.elementOptions?.forEach(item => {
    replaceAnimateContainerId(item.clickAnimates, data.baseSwiperContent_id, data.swiperContent_id)
    replaceAnimateContainerId(item.hoverAnimates, data.baseSwiperContent_id, data.swiperContent_id)
  })
}
const replaceAnimateContainerId = function (animates, baseSwiperContent_id, newSwiperContent_id) {
  animates?.forEach(animate => {
    if (animate?.ids && animate.ids.swiperContent_id === baseSwiperContent_id) {
      animate.ids.swiperContent_id = newSwiperContent_id
    }
    if (animate?.controlIds && animate.controlIds.swiperContent_id === baseSwiperContent_id) {
      animate.controlIds.swiperContent_id = newSwiperContent_id
    }
    animate?.passiveIds?.forEach((item, index) => {
      if (item.swiperContent_id === baseSwiperContent_id) {
        item.swiperContent_id = newSwiperContent_id
      }
    })
  })
  return animates
}
/**
 *   用于单元格同步，动画的同步
 */
export const colAnimateSync = function (data) {
  // 动画设置项已经通过同步的时候处理完成
  // 此处需要处理 将作用于当前单元格的uid 替换到为对应的uid
  let baseColUid = data.baseUid
  if (data.content.componentBoxOptions) {
    replaceAnimateUid(data.content.componentBoxOptions.clickAnimates, baseColUid, data.uid)
    replaceAnimateUid(data.content.componentBoxOptions.hoverAnimates, baseColUid, data.uid)
  }
  replaceCallBack(data.content.elementOptions)
  function replaceCallBack(elementOptions) {
    elementOptions?.forEach(item => {
      replaceAnimateUid(item.clickAnimates, baseColUid, data.uid)
      replaceAnimateUid(item.hoverAnimates, baseColUid, data.uid)
      clearUnUseProperties(item)
      if (item.elementOptions?.length) {
        // 有多层嵌套的情况如自动布局
        replaceCallBack(item.elementOptions)
      }
    })
  }
}
const clearUnUseProperties = function (rect) {
  if(rect.innerElement === "cxButton" && rect.popoverPath) {
    delete rect.popoverPath
  }
}
const replaceAnimateUid = function (animates, baseColUid, newUid) {
  animates?.forEach(animate => {
    if (animate?.ids?.uid && animate.ids.uid === baseColUid) {
      animate.ids.uid = newUid
    }
    if (animate?.controlIds?.uid && animate.controlIds.uid === baseColUid) {
      animate.controlIds.uid = newUid
    }
    animate?.passiveIds?.forEach((item, index) => {
      if (item.uid === baseColUid) {
        item.uid = newUid
      }
    })
  })
  return animates
}
const replaceAnimateCellId = function (animates, newCellId,res) {
  animates?.forEach(animate => {
    if (animate?.ids?.cellId && animate.ids.cellId && getOldCellId(animate.ids.cellId)) {
      animate.ids.cellId = res[animate.ids.cellId]
    }
    if (animate?.controlIds?.cellId && animate.controlIds.cellId && getOldCellId(animate.controlIds.cellId)) {
      animate.controlIds.cellId = res[animate.controlIds.cellId]
    }
    animate?.passiveIds?.forEach((item, index) => {
      if (item.cellId  && getOldCellId(item.cellId)) {
        item.cellId = res[item.cellId]
      }
    })
  })
  function getOldCellId(oldCellId){
    let newCellId = ""
    for (let cellKey in res) {
      if (cellKey === oldCellId) {
        newCellId = res[cellKey] + ""
        break
      }
    }
    return newCellId
  }
  return animates
}
/**
 *   深度修改布局组件格式数据的uid
 */
export function deepChangeAnimateUid(origin) {
  const res = {}
  deepChangeUidExcludeAnimate(origin, res)
  deepChangeAnimate(origin, res)
  return res
  function deepChangeAnimate(org, res) {
    if (org && typeof org === "object") {
      for (let k in org) {
        if (typeof org[k] === "object") {
          if (k === "componentBoxOptions" || k === "elementOptions") {
            changeUidOfAnimate(org, res, k)
          }
          deepChangeAnimate(org[k], res)
        }
      }
    }
  }
}
/**
 *   修改动画对象中的 cellId
 */
function changeCellIdOfAnimate(org, res, k, newCellId){
  let animateObj = k ? org[k] :org
  replaceAnimateCellId(animateObj.hoverAnimates,newCellId,res)
  replaceAnimateCellId(animateObj.clickAnimates,newCellId,res)
}
/**
 *   修改动画对象中的 uid
 */
function changeUidOfAnimate(org, res, k) {
  let oldUid = ""
  for (let uidKey in res) {
    if (res[uidKey] === org.uid) {
      oldUid = uidKey + ""
      break
    }
  }
  colAnimateSync({
    content: {
      [k]: org[k]
    },
    uid: org.uid,
    baseUid: oldUid
  })
}
/**
 *  通过ids查到对象的 options
 */
function getAnimateOption(stage, ids) {
  try{
    let rectAttr = getAttrById(stage, ids)
    if(!rectAttr){
      return rectAttr
    }
    if(ids.cellId){
      if(ids.elementInDataGridId){
        rectAttr = getAttrById(stage, ids, "elementInDataGrid")
      }else{
        rectAttr = getAttrById(stage, ids, "dataGridCell")
      }
      return  rectAttr
    } else if (!ids.uid) {
      if (ids.hasOwnProperty("elementInAutoLayoutId")) {
        rectAttr = getAttrById(stage, ids, "elementInAutoLayout")
        return rectAttr
      }
      return rectAttr.options
    } else {
      if (ids.hasOwnProperty("elementInLayoutId")) {
        // 自由布局组件内的 组件
        return rectAttr
      } else {
        const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
        const pOptions = [rectAttr.options.rows[useActiveIndex]]
        return handleFindLayoutComponentOptionsCols(pOptions, ids.uid)?.componentBoxOptions
      }
    }
  }catch(e){
    return undefined
  }
}

/**
 * 删除组件对应的动画关系、
 */
export const delAnimateInRect = function (stage, data, rect) {
  let _ids = idsFilter(data)
  // 组件id外的属性会影响动画时候，触发组件，响应组件的对比
  delete _ids.record
  let passiveOption
  let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
  let complexComponents = ["emptyLayoutComponent", "swiperComponent", "layoutComponent","cxDataGrid"]
  let rectOption = rect.options || rect //子组件没有option属性
  // 普通组件
  animateTypes.forEach(item => {
    rectOption[item]?.forEach(animate => {
      // 删除控制当前组件的动画 排除掉画布的情况
      if (objectSize(animate.controlIds) > 1 && !compareIds(_ids, animate.controlIds)) {
        // 删除控制组件中对应的动画
        passiveOption = getAnimateOption(stage, animate.controlIds)
        console.log("passiveOption111",passiveOption)

        delAnimateRelation(passiveOption, animate.controlIds, item, animate.animateId,stage)
      } else {
        // 只有控制动画的组件是当前被删除的组件，所有的被控制的组件的动画都要删除
        animate.passiveIds?.forEach(ids => {
          let animateIds = idsFilter(ids)
          if (objectSize(animateIds) > 1) {
            passiveOption = getAnimateOption(stage, animateIds)
            delAnimateRelation(passiveOption, _ids, item,animate.animateId)
          }
        })
      }
    })
  })
  // 复杂组件 需要处理子组件对应的动画关系
  if (complexComponents.indexOf(rect.shape) > -1) {
    delChildRectAnimateRelation(stage, rect, _ids, false, [rect.rect_id])
  }
}

/**
 * 删除组件对应的动画关系、
 * _ids 被删除组件的 id
 */
function delAnimateRelation(passiveOption, _ids, animateType, animateId,stage) {
  if (!passiveOption) {
    return
  }
  passiveOption = passiveOption.options || passiveOption
  let aniamtes = passiveOption[animateType] || []
  for (let i = 0; i < aniamtes.length; i++) {
    // 控住ids controlIds  和 _ids 相同，则表示当前动画是 改组件控制
    let isInclude = inChildRect(_ids, aniamtes[i].controlIds)
    // 删除组件的情况
    if (animateId === aniamtes[i].animateId || isInclude) {
      if(compareIds(aniamtes[i].controlIds, _ids)){
        if (aniamtes[i].passiveIds.length === 1 && compareIds(aniamtes[i].passiveIds[0], aniamtes[i].ids)) {
          // 删除当前动画
          console.log("aniamtes",aniamtes)
          aniamtes.splice(i, 1)
          break
        } else {
        for (let k = 0; k < aniamtes[i].passiveIds.length; k++) {
          if (compareIds(aniamtes[i].passiveIds[k], aniamtes[i].ids)) {
            aniamtes[i].passiveIds.splice(k, 1)
            let componentNameArr = aniamtes[i].componentName.split(" ")
            componentNameArr.splice(k, 1)
            aniamtes[i].componentName = componentNameArr.join(" ")
            break
            }
          }
        }
      }
    }
  }
}

/**
 * 上传系统样式，删除作用在当前样式之外的动画
 * rectIds 为该样式 或者 该通栏内组件 rectId的集合
 * isCloneRect 是否为克隆样式，如上传系统样式，此时是在克隆组件上改动画关系
 */
export const delAnimateOutCurrentRect = function (stage, data, rect, rectIds) {
  // 没有传参的时候 为单个组件
  rectIds = rectIds ? rectIds : [data.rect_id]
  let _ids = idsFilter(data)
  let passiveOption
  let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
  let complexComponents = ["emptyLayoutComponent", "swiperComponent", "layoutComponent","cxDataGrid"]
  let rectOption = rect.options || rect //子组件没有option属性
  // 普通组件
  animateTypes.forEach(item => {
    rectOption[item]?.forEach(animate => {
      // 删除控制当前组件的动画 排除掉画布的情况
      let controlRectIdIndex = rectIds.findIndex(rectId => rectId === animate.controlIds.rect_id)
      if (controlRectIdIndex === -1) {
        // 删除控制组件中对应的动画
        passiveOption = getAnimateOption(stage, animate.controlIds)
        delAnimateRelation(passiveOption, animate.controlIds, item,animate.animateId)
      } else {
        // 被控制动画的组件不在当前组件内，则删除掉
        animate.passiveIds?.forEach(ids => {
          let animateIds = idsFilter(ids)
          if (ids.rect_id !== _ids.rect_id) {
            passiveOption = getAnimateOption(stage, animateIds)
            delAnimateRelation(passiveOption, _ids, item,animate.animateId)
          }
        })
      }
    })
  })

  // 复杂组件 需要处理子组件对应的动画关系
  if (complexComponents.indexOf(rect.shape) > -1) {
    delChildRectAnimateRelation(stage, rect, _ids, true, rectIds)
  }
}
/**
 * 上传通栏样式，删除通栏外的动画
 * rectIds  通栏内组件的rectId集合
 */
export const delAnimateOutCurrentLayout = function (rect, rectIds, containerId) {
  let complexComponents = ["emptyLayoutComponent", "swiperComponent", "layoutComponent","cxDataGrid"]
  let rectOption = rect.options //子组件没有option属性
  // 普通组件
  // debugger
  delExtraAnimate(rectOption, rectIds)
  // 复杂组件 需要处理子组件对应的动画关系
  if (complexComponents.indexOf(rect.shape) > -1) {
    delLayoutChildRectAnimateRelation(rectOption, rectIds)
  }
}
/**
 * 删除多余动画，对于上传为系统样式/通栏样式的的组件 只删除自身的 组件关系
 * controlIds 不是自身组件的也无需删除
 */
function delExtraAnimate(rectOption, rectIds) {
  let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
  animateTypes.forEach(item => {
    rectOption[item]?.forEach((animate, index) => {
      // 删除控制当前组件的动画 排除掉画布的情况
      let controlRectIdIndex = rectIds.findIndex(rectId => rectId === animate.controlIds.rect_id)
      if (controlRectIdIndex > -1) {
        // 被控制动画的组件不在当前通栏内，则删除掉
        for (let i = 0; i < animate.passiveIds.length; i++) {
          let ids = animate.passiveIds[i]
          let passiveRectIdIndex = rectIds.findIndex(rectId => rectId === ids.rect_id)
          if (passiveRectIdIndex === -1) {
            animate.passiveIds.splice(i, 1)
            i--
          }
        }
      } else {
        // 删除当前动画
        rectOption[item].splice(index, 1)
      }
    })
  })
}
function delLayoutChildRectAnimateRelation(org, rectIds) {
  if (org && typeof org === "object") {
    if(org.innerElement === 'cxDataGrid'){
      org.cells.forEach(cell=>{
        // changeCellIdOfAnimate(cell, uidRelation, "options",cell.cellId)
        let cellOption = cell.options
        delExtraAnimate(cellOption, rectIds)
        cell.elementOptions.forEach(option => {
          delExtraAnimate(option, rectIds)
        })
      })
      return
    }
    for (let k in org) {
      if (typeof org[k] === "object") {
        if (k === "elementOptions" || k === "componentBoxOptions") {
          let objArr = Array.isArray(org[k]) ? org[k] : [org[k]]
          objArr.forEach(option => {
            let rectOption = option.options || option
            delExtraAnimate(rectOption, rectIds)
          })
        }
        delLayoutChildRectAnimateRelation(org[k], rectIds)
      }
    }
  }
}
/**
 * 新增通栏，调整通栏中的动画id
 * rectIds  通栏内组件的rectId集合
 */
export const editAnimateAddLayout = function (stage, rectIds, containerId) {
  let uidRelation = {}
  let complexComponents = ["emptyLayoutComponent", "swiperComponent", "layoutComponent","cxDataGrid"]
  let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
  rectIds.forEach(rectId => {
    let rect = getAttrById(stage, {
      container_id: containerId,
      rect_id: rectId.newRectId
    })
    // 复杂组件 需要处理子组件对应的动画关系
    if (complexComponents.indexOf(rect?.shape) > -1) {
      deepChangeUidExcludeAnimate(rect, uidRelation)
    }
  })
  rectIds.forEach(rectId => {
    let newRectId = rectId.newRectId
    let rect = getAttrById(stage, {
      container_id: containerId,
      rect_id: newRectId
    })
    let rectOption = rect?.options //子组件没有option属性
    if(!rectOption) return
    // 普通组件
    animateTypes.forEach(item => {
      rectOption[item]?.forEach(animate => {
        let oldRectId = animate.ids.rect_id
        if (objectSize(animate.controlIds) > 1 && !compareIds(animate.ids, animate.controlIds)) {
          // 只有控制动画的组件不是当前组件，被控制的组件中当前的rectId 都要发生改变
          animate.ids.rect_id = newRectId
          let tempRectId = rectIds.find(id => id.oldRectId === animate.controlIds.rect_id)
          animate.controlIds.rect_id = tempRectId ? tempRectId.newRectId : animate.controlIds.rect_id
          let newIds
          for (let k = 0; k < animate.passiveIds.length; k++) {
            let animateIds = idsFilter(animate.passiveIds[k])
            if(!animateIds){
              continue
            }
            if (animateIds.rect_id === oldRectId) {
              animateIds.rect_id = newRectId
              newIds = animateIds
            } else {
              let tempRectId = rectIds.find(id => id.oldRectId === animateIds.rect_id)
              animateIds.rect_id =  tempRectId ? tempRectId.newRectId:animateIds.rect_id
            }
          }
        } else {
          // 只有控制动画的组件是当前组件，所有的被控制的组件的rectId 都要发生改变
          animate.ids.rect_id = newRectId
          animate.controlIds.rect_id = newRectId
          animate.passiveIds?.forEach(ids => {
            let animateIds = idsFilter(ids)
            if (objectSize(animateIds) < 2) {
              return
            }
            if (ids.rect_id === oldRectId) {
              ids.rect_id = newRectId
            } else {
              let tempRectId = rectIds.find(id => id.oldRectId === ids.rect_id)
              ids.rect_id = tempRectId?tempRectId.newRectId:ids.rect_id
            }
          })
        }
      })
    })

    // 复杂组件 需要处理子组件对应的动画关系
    if (complexComponents.indexOf(rect?.shape) > -1) {
      changeChildRectAnimateRelation(stage, rect, newRectId, uidRelation, null,rectIds)
    }
  })
}

/**
 * 删除复杂组件中子组件对应的动画关系
 * isOnlyOutAnimate   true 仅删除不在该组件内的动画  false 删除所有动画
 * rectIds  通栏内组件的rectId集合
 */

function delChildRectAnimateRelation(stage, org, _ids, isOnlyOutAnimate, rectIds) {
  if (org && typeof org === "object") {
    if(org.shape === 'cxDataGrid'){
      delDataGridChildRectAnimateRelation(stage, org, _ids, isOnlyOutAnimate, rectIds)
      return
    }
    for (let k in org) {
      if (typeof org[k] === "object") {
        if (k === "elementOptions" || k === "componentBoxOptions") {
          let objArr = Array.isArray(org[k]) ? org[k] : [org[k]]
          objArr.forEach(option => {
            let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
            let rectOption = option.options || option
            let passiveOption
            animateTypes.forEach(item => {
              rectOption[item]?.forEach(animate => {
                // 删除控制当前组件的动画 排除掉画布的情况
                let isInclude = 0
                for (let i = 0; i < rectIds.length; i++) {
                  isInclude = inChildRect(_ids, animate.controlIds)
                  if (isInclude) {
                    isInclude++
                  }
                }
                if (!isInclude) {
                  // 删除控制组件中对应的动画
                  passiveOption = getAnimateOption(stage, animate.controlIds)
                  delAnimateRelation(passiveOption, animate.controlIds, item,animate.animateId)
                } else {
                  // 只有控制动画的组件是当前被删除的组件，所有的被控制的组件的动画都要删除
                  if (!isOnlyOutAnimate) {
                    animate.passiveIds?.forEach(ids => {
                      let animateIds = idsFilter(ids)
                      if (objectSize(animateIds) > 1) {
                        passiveOption = getAnimateOption(stage, animateIds)
                        delAnimateRelation(passiveOption, _ids, item,animate.animateId)
                      }
                    })
                  } else {
                    animate.passiveIds?.forEach(ids => {
                      let animateIds = idsFilter(ids)
                      if (animateIds?.rect_id !== _ids.rect_id) {
                        passiveOption = getAnimateOption(stage, animateIds)
                        delAnimateRelation(passiveOption, _ids, item,animate.animateId)
                      }
                    })
                  }
                }
              })
            })
          })
        }
        delChildRectAnimateRelation(stage, org[k], _ids, isOnlyOutAnimate, rectIds)
      }
    }
  }
}
/**
 * 删除复杂组件中子组件对应的动画关系
 * isOnlyOutAnimate   true 仅删除不在该组件内的动画  false 删除所有动画
 * rectIds  通栏内组件的rectId集合
 */

function delDataGridChildRectAnimateRelation(stage, org, _ids, isOnlyOutAnimate, rectIds) {
  if (org && typeof org === "object") {
    org.options.cells.forEach(cell=>{
      let cellOption = cell.options
      delDataGridChildAnimate(cellOption,stage, _ids, isOnlyOutAnimate, rectIds)
      cell.elementOptions.forEach(option => {
        delDataGridChildAnimate(option,stage, _ids, isOnlyOutAnimate, rectIds)
      })
    })
  }
}
function  delDataGridChildAnimate(rectOption,stage, _ids, isOnlyOutAnimate, rectIds){
  let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
  let passiveOption
  animateTypes.forEach(item => {
    rectOption[item]?.forEach(animate => {
      // 删除控制当前组件的动画 排除掉画布的情况
      let isInclude = 0
      for (let i = 0; i < rectIds.length; i++) {
        isInclude = inChildRect(_ids, animate.controlIds)
        if (isInclude) {
          isInclude++
        }
      }
      if (!isInclude) {
        // 删除控制组件中对应的动画
        passiveOption = getAnimateOption(stage, animate.controlIds)
        delAnimateRelation(passiveOption, animate.controlIds, item,animate.animateId)
      } else {
        // 只有控制动画的组件是当前被删除的组件，所有的被控制的组件的动画都要删除
        if (!isOnlyOutAnimate) {
          animate.passiveIds?.forEach(ids => {
            let animateIds = idsFilter(ids)
            if (objectSize(animateIds) > 1) {
              passiveOption = getAnimateOption(stage, animateIds)
              delAnimateRelation(passiveOption, _ids, item,animate.animateId)
            }
          })
        } else {
          animate.passiveIds?.forEach(ids => {
            let animateIds = idsFilter(ids)
            if (animateIds?.rect_id !== _ids.rect_id) {
              passiveOption = getAnimateOption(stage, animateIds)
              delAnimateRelation(passiveOption, _ids, item,animate.animateId)
            }
          })
        }
      }
    })
  })
}
/**
 * 复制组件时，同时复制动画
 * oldRectID 被复制的rectId
 *  newRectId 新生成的rectId
 */
export const copyAnimateRelation = function (stage, rect, oldRectID, newRectId) {
  let oldRectId = oldRectID
  let complexComponents = ["emptyLayoutComponent", "swiperComponent", "layoutComponent","cxDataGrid"]
  let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
  let passiveOption
  let rectOption = rect.options || rect //子组件没有option属性
  // 普通组件
  animateTypes.forEach(item => {
    rectOption[item]?.forEach(animate => {
      oldRectId = typeof oldRectId === "undefined" ? animate.ids.rect_id : oldRectId
      if (objectSize(animate.controlIds) > 1 && !compareIds(animate.ids, animate.controlIds)) {
        // 只有控制动画的组件不是当前组件，被控制的组件中当前的rectId 都要发生改变
        animate.ids.rect_id = newRectId
        let newIds
        for (let k = 0; k < animate.passiveIds.length; k++) {
          let animateIds = idsFilter(animate.passiveIds[k])
          if (animateIds.rect_id === oldRectId) {
            animateIds.rect_id = newRectId
            newIds = animateIds
            break
          }
        }
        // 控制组件动画的组件 新增一个动画
        let controlOption = getAnimateOption(stage, animate.controlIds)
        if (!controlOption) return
        let activeAnimate = controlOption[item]?.find(animateItem => (animateItem.animateId = animate.animateId))
        if(activeAnimate){
          let hasOwned = activeAnimate.passiveIds.find(ids=>compareIds(ids,newIds))
          if(!hasOwned){
            activeAnimate.passiveIds.push(newIds)
            activeAnimate.componentName += " " + rectOption.menuName || ""
          }
        }
      } else {
        // 只有控制动画的组件是当前组件，所有的被控制的组件的动画 都要新增一个动画
        let passiveRects = []
        animate.ids.rect_id = newRectId
        animate.controlIds.rect_id = newRectId
        animate.passiveIds?.forEach(ids => {
          let animateIds = idsFilter(ids)
          if (objectSize(animateIds) < 2) {
            return
          }
          if (ids.rect_id === oldRectId) {
            ids.rect_id = newRectId
          } else {
            passiveRects.push(animateIds)
          }
        })
        passiveRects.forEach(ids => {
          passiveOption = getAnimateOption(stage, ids)
          if (passiveOption) {
            changeAnimateRelation(passiveOption, animate.animateId, animate, item)
          }
        })
      }
    })
  })

  // 复杂组件 需要处理子组件对应的动画关系
  if (complexComponents.indexOf(rect.shape) > -1) {
    let uidRelation = {}
    deepChangeUidExcludeAnimate(rect, uidRelation)
    changeChildRectAnimateRelation(stage, rect, newRectId, uidRelation, oldRectID)
  }
  // }
}

/**
 * 复制单元格，同时复制动画
 * rectOption 单元格的
 *
 */
export const copyColAnimateRelation = function (stage, rectOption) {
  let uidRelation = {}
  deepChangeUidExcludeAnimate(rectOption, uidRelation)
  changeColChildRectAnimateRelation(stage, rectOption, uidRelation)
}

/**
 * 删除单元格，同时删除单元格内组件控制在外部其他组件上的动画
 * org 单元格内的的 elementOptions
 * colIds 当前单元格的 ids
 */
export const delColAnimateRelation = function (stage, elementOptions, colIds) {
  delChildRectAnimateRelation(stage, { elementOptions: elementOptions }, colIds, true, [colIds])
}

/**
 * 修改动画关系
 */
function changeAnimateRelation(passiveOption, animateId, newAnimate, animateType) {
  let aniamtes = passiveOption[animateType] || []
  for (let i = 0; i < aniamtes.length; i++) {
    if (aniamtes[i].animateId === animateId) {
      aniamtes.splice(i, 1, newAnimate)
      break
    }
  }
}
/**
 * 修改复杂组件中子组件对应的动画关系
 */
function changeChildRectAnimateRelation(stage, org, newRectId, uidRelation, oldRectId,rectIds) {
  if (org && typeof org === "object") {
    if(org.shape === 'cxDataGrid'){
      changeDataGridChildRectAnimateRelation(stage, org, newRectId, uidRelation, oldRectId,rectIds)
      return
    }
    for (let k in org) {
      if (typeof org[k] === "object") {
        if (k === "elementOptions" || k === "componentBoxOptions") {
          changeUidOfAnimate(org, uidRelation, k)
          let objArr = Array.isArray(org[k]) ? org[k] : [org[k]]
          objArr.forEach(option => {
            let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
            let rectOption = option.options || option
            let passiveOption
            animateTypes.forEach(item => {
              if(rectOption[item] && rectOption[item].length>0){
                rectOption[item].forEach(animate => {
                  oldRectId = typeof oldRectId === "undefined" ? animate.ids.rect_id : oldRectId
                  // 新增控制当前组件的动画
                  let isInclude = oldRectId == animate.controlIds.rect_id ? true : false
                  if (!isInclude) {
                    // 只有控制动画的组件不是当前组件，被控制的组件中当前的rectId 都要发生改变
                    animate.ids.rect_id = newRectId
                    if(rectIds &&  rectIds.find(id => id.oldRectId === animate.controlIds.rect_id)?.newRectId){
                      animate.controlIds.rect_id = rectIds.find(id => id.oldRectId === animate.controlIds.rect_id)?.newRectId
                    }
                    let newIds
                    for (let k = 0; k < animate.passiveIds.length; k++) {
                      let animateIds = idsFilter(animate.passiveIds[k])
                      if(rectIds){
                        let _rectId = rectIds.find(id => id.oldRectId === animateIds.rect_id)
                        if(_rectId && _rectId.newRectId){
                          animateIds.rect_id = _rectId.newRectId
                          newIds = animateIds
                          // break
                        }
                      }else if (animateIds?.rect_id === oldRectId && isExist(oldRectId) ) {
                        animateIds.rect_id = newRectId || animateIds.rect_id
                        newIds = animateIds
                        // break
                      }
                    }
                    // 控制组件动画的组件 新增一个动画
                    let controlOption = getAnimateOption(stage, animate.controlIds)
                    if (!controlOption) return
                    let activeAnimate = controlOption[item]?.find(
                        animateItem => (animateItem.animateId = animate.animateId)
                    )
                    if(activeAnimate){
                      let hasOwned = activeAnimate.passiveIds.find(ids=>compareIds(ids,newIds))
                      if(!hasOwned){
                        activeAnimate.passiveIds.push(newIds)
                        activeAnimate.componentName += " " + rectOption.menuName || ""
                      }
                    }
                  } else {
                    // 只有控制动画的组件是当前组件，所有的被控制的组件的rectId 都要发生改变
                    let passiveRects = []
                    animate.ids.rect_id = newRectId
                    animate.controlIds.rect_id = newRectId
                    animate.passiveIds?.forEach(ids => {
                      let animateIds = idsFilter(ids)
                      if (objectSize(animateIds) < 2) {
                        return
                      }
                      if (ids.rect_id === oldRectId) {
                        ids.rect_id = newRectId
                      } else {
                        passiveRects.push(animateIds)
                      }
                    })
                    passiveRects.forEach(ids => {
                      passiveOption = getAnimateOption(stage, ids)
                      let newAnimate = JSON.parse(JSON.stringify(animate))
                      if (passiveOption[item]) {
                        passiveOption[item].push(newAnimate)
                      } else {
                        passiveOption[item] = [newAnimate]
                      }
                    })
                  }
                })
              }
            })
          })
        }
        changeChildRectAnimateRelation(stage, org[k], newRectId, uidRelation, oldRectId,rectIds)
      }
    }
  }
}

/**
 * 修改复杂组件列表数据组件中子组件对应的动画关系
 */
function changeDataGridChildRectAnimateRelation(stage, org, newRectId, uidRelation, oldRectId,rectIds) {
  org.options.cells.forEach((cell,index)=>{
    changeCellIdOfAnimate(cell, uidRelation, "options",cell.cellId)
    let cellOption = cell.options
    replaceAnimateRectIdOfDataGrid(cellOption,stage,org, newRectId, uidRelation, oldRectId,rectIds)
    cell.elementOptions.forEach(option => {
       let rectOption = option.options || option
      changeCellIdOfAnimate(rectOption,uidRelation,"",cell.cellId)
      replaceAnimateRectIdOfDataGrid(rectOption,stage,org, newRectId, uidRelation, oldRectId,rectIds)
     })
  })
}
function replaceAnimateRectIdOfDataGrid(cellOption,stage,org, newRectId, uidRelation, oldRectId,rectIds){
  // todo 有bug,待优化
  let passiveOption
  let animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
  animateTypes.forEach(item => {
    if(cellOption[item] && cellOption[item].length>0){
      cellOption[item].forEach(animate => {
        oldRectId = typeof oldRectId === "undefined" ? animate.ids.rect_id : oldRectId
        // 新增控制当前组件的动画
        let isInclude = oldRectId == animate.controlIds.rect_id ? true : false
        if (!isInclude) {
          // 只有控制动画的组件不是当前组件，被控制的组件中当前的rectId 都要发生改变
          if(newRectId){
            animate.ids.rect_id = newRectId
          }else if(rectIds.find(id => id.oldRectId === animate.ids.rect_id)){
            animate.ids.rect_id = rectIds.find(id => id.oldRectId === animate.ids.rect_id).newRectId
          }
          if(rectIds && rectIds.find(id => id.oldRectId === animate.controlIds.rect_id)){
            animate.controlIds.rect_id = rectIds.find(id => id.oldRectId === animate.controlIds.rect_id).newRectId
          }
          for (let k = 0; k < animate.passiveIds.length; k++) {
            let animateIds = idsFilter(animate.passiveIds[k])
            if(rectIds){
              let newId = rectIds.find(id => id.oldRectId === animateIds.rect_id).newRectId
              if(newId){
                animateIds.rect_id = newId
              }
            }else if (animateIds?.rect_id === oldRectId && isExist(newRectId)) {
              animateIds.rect_id = newRectId
            }
          }
          // 控制组件动画的组件 新增一个动画
          let controlOption = getAnimateOption(stage, animate.controlIds)
          if (!controlOption) return
          let activeAnimate = controlOption[item]?.find(
              animateItem => (animateItem.animateId = animate.animateId)
          )
          if(activeAnimate){
            activeAnimate.passiveIds =animate.passiveIds

            // activeAnimate.passiveIds.push(newIds)
            // activeAnimate.componentName += " " + cellOption.menuName || ""
          }
        } else {
          // 只有控制动画的组件是当前组件，所有的被控制的组件的rectId 都要发生改变
          let passiveRects = []
          animate.ids.rect_id = newRectId
          animate.controlIds.rect_id = newRectId
          animate.passiveIds?.forEach(ids => {
            let animateIds = idsFilter(ids)
            if (objectSize(animateIds) < 2) {
              return
            }
            if (ids.rect_id === oldRectId) {
              ids.rect_id = newRectId
            } else {
              passiveRects.push(animateIds)
            }
          })
          passiveRects.forEach(ids => {
            passiveOption = getAnimateOption(stage, ids)
            let newAnimate = JSON.parse(JSON.stringify(animate))
            if (passiveOption[item]) {
              passiveOption[item].push(newAnimate)
            } else {
              passiveOption[item] = [newAnimate]
            }
          })
        }
      })
    }
  })
}
/**
 * 修改单元格中子组件对应的动画关系
 */
function changeColChildRectAnimateRelation(stage, org, uidRelation) {
  if (org && typeof org === "object") {
    for (let k in org) {
      if (typeof org[k] === "object") {
        if (k === "elementOptions" || k === "componentBoxOptions") {
          changeUidOfAnimate(org, uidRelation, k)
        }
        changeColChildRectAnimateRelation(stage, org[k], uidRelation)
      }
    }
  }
}


// 删除组件内的动画组合 animateGroup
export function delAnimateGroup(rectAttrOptions){
  delete rectAttrOptions.animateGroup
  if(rectAttrOptions.innerElement === 'cxAutoLayout'){
    rectAttrOptions.elementOptions?.forEach(options=>{
      delete options.animateGroup
    })
  }
}